export default __webpack_public_path__ + "static/media/St-Johns-Logo.ed682470.png";